import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rider-payor-grid',
  templateUrl: './rider-payor-grid.component.html',
  styleUrls: ['./rider-payor-grid.component.scss']
})
export class RiderPayorGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-payor-grid/rider-payor-grid.component.ts